<template>
	<div>
		<q-btn-dropdown
			:label="getCountryLabel"
			icon="fal fa-globe"
			flat
			v-model="show_countries"
			v-if="user_countries.length > 1"
		>
			<q-list link>
				<q-item
					v-for="(item, index) in user_countries"
					:key="index"
					v-if="id_user_client_country_selected != item.id"
					@click.native="changeCountry(item)"
				>
					<q-item-main>
						<q-item-tile label>{{ item.name }}</q-item-tile>
					</q-item-main>
				</q-item>
			</q-list>
		</q-btn-dropdown>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	data() {
		return {
			show_countries: false,
		}
	},
	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			id_user_client_selected: 'common/id_user_client_selected',
			id_user_language_selected: 'common/id_user_language_selected',
			reload_content: 'common/reload_content',
			user_clients: 'common/user_clients',
			user_countries: 'common/user_countries',
			user_module_items: 'common/user_module_items',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		getCountryLabel() {
			let obj = this.user_countries.find((obj) => {
				return obj.id == this.id_user_client_country_selected
			})
			if (obj) return obj.name
			else return ''
		},
	},
	methods: {
		changeCountry(item) {
			this.$store.dispatch('common/SET_COUNTRY', [item.id])
			this.show_countries = false
			this.setUserSelection()
		},

		getCountryList(type) {
			let obj = this.user_clients.find((obj) => obj.id == this.id_user_client_selected)
			if (obj) {
				this.$store.dispatch('common/SET_USER_COUNTRIES', [obj.countries])

				if (type === 'changed_client') {
					let obj_countries = obj.countries.find(
						(obj) => obj.id == this.id_user_client_country_selected
					)
					if (!obj_countries)
						this.$store.dispatch('common/SET_COUNTRY', [this.user_countries[0].id])
					this.setUserSelection()
				}
			}
		},

		setUserSelection() {
			this.$q.loading.show()
			let fd = new FormData()
			fd.append('client', this.id_user_client_selected)
			fd.append('country', this.id_user_client_country_selected)
			fd.append('language', this.id_user_language_selected)

			this.$axios
				.post('/accounts/set_user_selection/', fd, this.getHeader)
				.then((response) => {
					this.getUserData()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		getUserData() {
			this.$axios
				.get('/accounts/read_user_data/', this.getHeader)
				.then((response) => {
					const d = response.data

					this.$store.dispatch('common/SET_USER_DATA', [
						d.id,
						d.id_user_client_profile,
						d.full_name,
						d.document,
						d.id_user_client_selected,
						d.id_user_client_country_selected,
						d.id_user_language_selected,
						d.user_clients,
						d.user_client_module_items,
						d.user_firebase_document,
						d.is_superuser,
						d.email,
						d.user_firebase_document_ranking_areas,
						d.has_mandatory_surveys,
						d.accept_terms_and_conditions,
						d.user_companies,
						d.user_branches,
					])

					const obj = this.clients.find((obj) => obj.id == this.id_user_client_selected)

					if ([obj.home_route, 'admin_overview'].indexOf(this.$route.name) != -1)
						this.$store.dispatch('common/SET_RELOAD_CONTENT', [!this.reload_content])
					else {
						if (this.$router.currentRoute.fullPath.split('/') >= 3)
							this.$router.replace({ name: 'admin_overview' })
						else this.$router.replace({ name: obj.home_route })
					}
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},
	},

	watch: {
		id_user_client_selected: function() {
			if (this.user_clients && !this.$q.platform.is.mobile) {
				this.getCountryList('changed_client')
			}
		},
	},

	created() {
		this.getCountryList('first_load')
	},
}
</script>

<style></style>
